export const POLITICAL_ROLES = [
  { value: 'vereador', label: 'Vereador' },
  { value: 'prefeito', label: 'Prefeito' },
  { value: 'deputado_estadual', label: 'Deputado Estadual' },
  { value: 'deputado_federal', label: 'Deputado Federal' },
  { value: 'governador', label: 'Governador' },
  { value: 'presidente', label: 'Presidente' },
];

export const roleLabel = value =>
  POLITICAL_ROLES.find(r => r.value === value)?.label || '';
